module.exports = __webpack_public_path__ + "static/img/news.af7b582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news.jpg
// module id = Mqtb
// module chunks = 0